module.exports = __webpack_public_path__ + "static/img/GLT1350-FCM-325-BB-2.c43fd41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/GLT1350-FCM-325-BB-2.jpg
// module id = OBfS
// module chunks = 0